/**
 * 权限管理模块 - Vuex版本
 */
const state = {
  // 存储权限数组
  rolePermissions: []
}

const mutations = {
  // 设置权限
  SET_PERMISSIONS(state, permissions) {
    state.rolePermissions = permissions || []
  },
  
  // 清除权限
  CLEAR_PERMISSIONS(state) {
    state.rolePermissions = []
  }
}

const actions = {
  // 登录时调用，将权限存入Vuex
  setPermissions({ commit }, permissions) {
    commit('SET_PERMISSIONS', permissions)
  },
  
  // 清除权限
  clearPermissions({ commit }) {
    commit('CLEAR_PERMISSIONS')
  }
}

const getters = {
  // 判断是否拥有某个权限
  hasPermission: state => permission => {
    if (!permission) return false
    return state.rolePermissions.includes(permission)
  },
  
  // 判断是否拥有任一权限（OR逻辑）
  hasAnyPermission: state => permissions => {
    if (!permissions || !Array.isArray(permissions)) return false
    return permissions.some(permission => state.rolePermissions.includes(permission))
  },
  
  // 判断是否拥有所有权限（AND逻辑）
  hasAllPermissions: state => permissions => {
    if (!permissions || !Array.isArray(permissions)) return false
    return permissions.every(permission => state.rolePermissions.includes(permission))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
